import queryString from 'query-string';

import { getFeedDetailMatch, getProfileMatch, getTeamMatch, getTeamSettingsMatch } from 'constants/helper';

function getBodyForAuthenticationCall({ path, locationSearch }) {
  const teamMatch = getTeamMatch(path);
  const teamSettingsMatch = getTeamSettingsMatch(path);
  const feedDetailMatch = getFeedDetailMatch(path);
  const { teamType = null } = queryString.parse(locationSearch);

  let body = {};
  if (teamMatch || teamSettingsMatch) {
    const teamId = teamMatch ? teamMatch.params.teamId : teamSettingsMatch.params.teamId;
    body = { landingPageType: 'TEAM', landingPageUuid: teamId, ...(teamType && { teamType }) };
  } else if (feedDetailMatch) {
    const { feedId } = feedDetailMatch.params;
    body = { landingPageType: 'FEED', landingPageUuid: feedId };
  } else {
    const profileMatch = getProfileMatch(path);
    if (profileMatch) {
      const { employeeId } = profileMatch.params;
      body = { landingPageType: 'EMPLOYEE', landingPageUuid: employeeId };
    }
  }
  return body;
}

export default getBodyForAuthenticationCall;
